
// export function truncatePartyNames(partyString, maxLength = 60) {
//   if (!partyString || partyString.length <= maxLength) return partyString;

//   const parts = partyString.split(/ vs Versus vs /i);
//   if (parts.length !== 2) return partyString.length > maxLength ? partyString.slice(0, maxLength) + "..." : partyString;

//   const [left, right] = parts;

//   const buffer = " vs Versus vs ".length;
//   const maxEach = Math.floor((maxLength - buffer - 6) / 2);

//   const shortLeft = left.length > maxEach ? left.slice(0, maxEach) + "..." : left;
//   const shortRight = right.length > maxEach ? right.slice(0, maxEach) + "..." : right;

//   return `${shortLeft}  Versus  ${shortRight}`;
// }

// export function fullTruncatePartyNames(partyString, maxLength = 60) {
//   if (!partyString || partyString.length <= maxLength) return partyString;

//   const parts = partyString.split(/ vs Versus vs /i);
//   if (parts.length !== 2) return partyString.length > maxLength ? partyString.slice(0, maxLength) + "..." : partyString;

//   const [left, right] = parts;

//   const buffer = " vs Versus vs ".length;
//   const maxEach = Math.floor((maxLength - buffer - 6) / 2);

//   const shortLeft = left;
//   const shortRight = right;

//   return `${shortLeft}  Versus  ${shortRight}`;
// }



// export function formatPartyNames(partyString, maxLength = 45) {
//   if (!partyString) return partyString;

//   const parts = partyString.split(/ vs Versus vs /i);
//   if (parts.length !== 2) return partyString.length > maxLength ? partyString.slice(0, maxLength) + "..." : partyString;

//   const [left, right] = parts;

//   const maxEach = 10;

//   const shortLeft = left.slice(0, maxEach) + "..";
//   const shortRight = right.slice(0, maxEach) + "..";

//   return `${shortLeft} vs ${shortRight}`;
// }



// export function formatCourtType(type) {
//   if (!type) return '';

//   return type
//     .split('-')
//     .map(word => word.charAt(0).toUpperCase() + word.slice(1))
//     .join(' ');
// };

// Helper function to normalize party names format
export function normalizePartyNames(partyString) {
  if (!partyString) return partyString;
  
  // Handle various malformed patterns
  let normalized = partyString;
  
  // Pattern 1: "partyA vs partyBpartyA partyB" - Remove duplicated parties
  normalized = normalized.replace(/^(.+?)\s+vs\s+(.+?)\1\s+\2$/i, '$1 vs $2');
  
  // Pattern 2: "partyA vs vs vs partyB" - Multiple vs/versus
  normalized = normalized.replace(/\s+(vs|versus)\s+(vs|versus)\s+(vs|versus)\s+/gi, ' vs ');
  normalized = normalized.replace(/\s+(vs|versus)\s+(vs|versus)\s+/gi, ' vs ');
  
  // Pattern 3: "partyAversuspartyB" - No spaces around versus
  normalized = normalized.replace(/([a-zA-Z])(versus)([a-zA-Z])/gi, '$1 vs $3');
  
  // Pattern 4: "partyAvsvsvspartyB" - Multiple vs without spaces
  normalized = normalized.replace(/([a-zA-Z])(vs){2,}([a-zA-Z])/gi, '$1 vs $3');
  
  // Pattern 5: "partyA versur vs versus partyB" - Typos and mixed separators
  normalized = normalized.replace(/\s+(versur|versus|vs)\s+(vs|versus)\s+(versus|vs)\s+/gi, ' vs ');
  
  // Clean up any remaining multiple spaces
  normalized = normalized.replace(/\s+/g, ' ').trim();
  
  // Ensure there's only one main separator
  const parts = normalized.split(/\s+(vs|versus)\s+/i);
  if (parts.length > 2) {
    // Take first and last meaningful parts
    const firstPart = parts[0].trim();
    const lastPart = parts[parts.length - 1].trim();
    normalized = `${firstPart} vs ${lastPart}`;
  }
  
  return normalized;
}

export function truncatePartyNames(partyString, maxLength = 60) {
  if (!partyString) return partyString;
  
  // First normalize the party names format
  const normalized = normalizePartyNames(partyString);
  
  if (normalized.length <= maxLength) return normalized;
  
  const parts = normalized.split(/\s+(vs|versus)\s+/i);
  if (parts.length < 2) {
    return normalized.length > maxLength ? normalized.slice(0, maxLength) + "..." : normalized;
  }
  
  const [left, right] = [parts[0].trim(), parts[parts.length - 1].trim()];
  const separator = " vs ";
  const buffer = separator.length;
  const maxEach = Math.floor((maxLength - buffer - 6) / 2);
  
  const shortLeft = left.length > maxEach ? left.slice(0, maxEach) + "..." : left;
  const shortRight = right.length > maxEach ? right.slice(0, maxEach) + "..." : right;

  return `${shortLeft}${separator}${shortRight}`;
}

export function fullTruncatePartyNames(partyString, maxLength = 60) {
  if (!partyString) return partyString;
  
  // First normalize the party names format
  const normalized = normalizePartyNames(partyString);
  
  if (normalized.length <= maxLength) return normalized;
  
  const parts = normalized.split(/\s+(vs|versus)\s+/i);
  if (parts.length < 2) {
    return normalized.length > maxLength ? normalized.slice(0, maxLength) + "..." : normalized;
  }
  
  const [left, right] = [parts[0].trim(), parts[parts.length - 1].trim()];
  
  return `${left} vs ${right}`;
}

export function formatPartyNames(partyString, maxLength = 45) {
  if (!partyString) return partyString;
  
  // First normalize the party names format
  const normalized = normalizePartyNames(partyString);
  
  const parts = normalized.split(/\s+(vs|versus)\s+/i);
  if (parts.length < 2) {
    return normalized.length > maxLength ? normalized.slice(0, maxLength) + "..." : normalized;
  }
  
  const [left, right] = [parts[0].trim(), parts[parts.length - 1].trim()];
  const maxEach = 10;
  
  const shortLeft = left.slice(0, maxEach) + "..";
  const shortRight = right.slice(0, maxEach) + "..";

  return `${shortLeft} vs ${shortRight}`;
}

export function formatCourtType(type) {
  if (!type) return '';
  return type
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export const formatText = (input) => {
  if (!input || typeof input !== 'string') {
    return input || '';
  }

  return input
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};


// Utility function to format ISO date string to readable format
export const formatDateTime = (isoString, options = {}) => {
  if (!isoString) return "--";
  
  try {
    const date = new Date(isoString);
    
    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return "--";
    }
    
    const {
      dateOnly = false,        // Show only date, no time
      timeOnly = false,        // Show only time, no date
      format24Hour = true,     // Use 24-hour format
      includeSeconds = false,  // Include seconds in time
      locale = 'en-IN',        // Indian locale by default
      dateStyle = 'medium',    // 'short', 'medium', 'long', 'full'
      timeStyle = 'short'      // 'short', 'medium', 'long'
    } = options;
    
    if (dateOnly) {
      return date.toLocaleDateString(locale, {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
      });
    }
    
    if (timeOnly) {
      return date.toLocaleTimeString(locale, {
        hour12: !format24Hour,
        hour: '2-digit',
        minute: '2-digit',
        ...(includeSeconds && { second: '2-digit' })
      });
    }
    
    // Default: Both date and time
    return date.toLocaleString(locale, {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: !format24Hour,
      ...(includeSeconds && { second: '2-digit' })
    });
    
  } catch (error) {
    console.error('Error formatting date:', error);
    return "--";
  }
};